var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15.875H20.75M1.25 11H20.75M20.75 6.125H1.25M11 20.75V1.25M1.25 20.1V1.9C1.25 1.72761 1.31848 1.56228 1.44038 1.44038C1.56228 1.31848 1.72761 1.25 1.9 1.25H20.1C20.2724 1.25 20.4377 1.31848 20.5596 1.44038C20.6815 1.56228 20.75 1.72761 20.75 1.9V20.1C20.75 20.2724 20.6815 20.4377 20.5596 20.5596C20.4377 20.6815 20.2724 20.75 20.1 20.75H1.9C1.72761 20.75 1.56228 20.6815 1.44038 20.5596C1.31848 20.4377 1.25 20.2724 1.25 20.1Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.e1b5f1ee7296c029a0bbaf3f9849d8a8.svg";
export { ForwardRef as ReactComponent };